// 发票申请接口
// /online/supplier-invoice/invoice-application

import Axios from '@/plugins/axios'
// 发票申请
// /mk-leads/online/supplier-invoice/invoice-application
export function invoiceApplication(params) {
  const config = {
    url:   '/mk-leads/online/supplier-invoice/invoice-application',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 开具发票列表接口
// /online/supplier-invoice/invoice-generator-list
export function invoiceGeneratorList(params) {
  const config = {
    url:   '/mk-leads/online/supplier-invoice/invoice-generator-list',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 开票记录列表
// /mk-leads/online/supplier-invoice/invoice-record
export function invoiceRecord(params) {
  const config = {
    url:   '/mk-leads/online/supplier-invoice/invoice-record-list',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
// 开票记录列表-撤回
// /mk-leads/online/supplier-invoice/invoice-record-withdraw
export function invoiceRecordWithdraw(params) {
  const config = {
    url:   '/mk-leads/online/supplier-invoice/invoice-record-withdraw',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}

// 开票记录列表-详情
// /mk-leads/online/supplier-invoice/invoice-record-detail
export function invoiceRecordDetail(params) {
  const config = {
    url:   '/mk-leads/online/supplier-invoice/invoice-record-detail',
    method: 'POST',
    data: params,
    noMessage: true,
  }
  return Axios(config)
}

// 总个数，总金额
export function invoiceRecordListNum(params) {
  const config = {
    url:   '/mk-leads/online/supplier-invoice/invoice-record-list-num',
    method: 'POST',
    data: params,
  }
  return Axios(config)
}
